// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Organization lifecycle status.
 */
export enum OrgStatus {
  DRAFT = 0,
  ACTIVE = 1,
}
